import { render, staticRenderFns } from "./symbol-icon.vue?vue&type=template&id=4e57ac71&scoped=true&"
import script from "./symbol-icon.vue?vue&type=script&lang=js&"
export * from "./symbol-icon.vue?vue&type=script&lang=js&"
import style0 from "./symbol-icon.vue?vue&type=style&index=0&id=4e57ac71&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e57ac71",
  null
  
)

export default component.exports